import {
  LoadExtractHistoryCacheUsecase,
  LoadExtractHistoryCacheUsecaseImpl,
} from 'domain/usecases/extract/load-extracts-history-cache-usecase';
import { makeLoadExtractHistoryFromCacheRepository } from '../repositories/cache/extract-history-repository-factory';

export const makeLoadExtractsHistoryUsecase = (): LoadExtractHistoryCacheUsecase => {
  return new LoadExtractHistoryCacheUsecaseImpl(makeLoadExtractHistoryFromCacheRepository());
};
